import { render, staticRenderFns } from "./qesg-dash-card.vue?vue&type=template&id=6422228c&"
import script from "./qesg-dash-card.vue?vue&type=script&lang=js&"
export * from "./qesg-dash-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports